import { useEffect, useRef } from "react";
import defaultHeroBg from "@/assets/heroes/default-hero-bg.jpg";

interface HeroSectionProps {
  badge?: string;
  title: string;
  subtitle?: string;
  backgroundImage?: string;
  children?: React.ReactNode;
}

export const HeroSection = ({ badge, title, subtitle, backgroundImage, children }: HeroSectionProps) => {
  const bgImage = backgroundImage || defaultHeroBg;
  const bgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (bgRef.current) {
        bgRef.current.style.transform = `translateY(${window.scrollY * 0.4}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="relative py-24 lg:py-32 overflow-hidden">
      <div
        ref={bgRef}
        className="absolute inset-0 -top-20 -bottom-20 bg-cover bg-center will-change-transform"
        style={{ backgroundImage: `url(${bgImage})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-black/65" aria-hidden="true" />
      <div className="relative z-10 container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          {badge && (
            <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 text-white/90 font-medium text-sm mb-4 backdrop-blur-sm border border-white/20">
              {badge}
            </span>
          )}
          <h1 className="text-4xl lg:text-5xl font-heading font-bold text-white mb-6">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
              {subtitle}
            </p>
          )}
          {children}
        </div>
      </div>
    </section>
  );
};
